import StyledLink from '../StyledLink'
import {
  DUPLICATE,
  SPACES
} from '../routes'
import type { Props } from '../types'

interface Params {
  spaceId: string
}

const LinkToDuplicateSpace = ({
  children,
  spaceId,
  openInNewTab,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    openInNewTab={openInNewTab}
    to={'/' + SPACES + '/' + spaceId + '/' + DUPLICATE}
  >
    {children}
  </StyledLink>

export default LinkToDuplicateSpace
